import getFlightDetailsByOrderItems from 'lib/flights/getFlightDetailsByOrderItems'
import { canAddInsuranceBookingProtectionToOrder } from 'lib/order/orderInsuranceBookingProtectionUtils'
import { createSelector } from 'reselect'

const isInsuranceBookingProtectionPostPurchaseEnabled = createSelector(
  (state: App.State, order?: App.Order) => order,
  (state: App.State) => state.orders.flightDetails,
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => state.offer.offers,
  (state: App.State) => state.experience.experiences,
  (state: App.State) => state.experience.bookingDetails,
  (order, flightDetails, regionCode, checkoutExistingOrder, offers, experiencesOffers, experienceBookingDetails) => {
    if (!order && !checkoutExistingOrder) return false

    const selectedOrder = order ?? checkoutExistingOrder!
    const flightDetailsByOrderItems = getFlightDetailsByOrderItems(selectedOrder, flightDetails)

    return canAddInsuranceBookingProtectionToOrder(
      selectedOrder, regionCode, flightDetailsByOrderItems ?? {}, offers, experiencesOffers, experienceBookingDetails,
    )
  },
)

export default isInsuranceBookingProtectionPostPurchaseEnabled
